import { render, staticRenderFns } from "./OperationalLimits.vue?vue&type=template&id=0249b4e8&scoped=true"
import script from "./OperationalLimits.vue?vue&type=script&lang=js"
export * from "./OperationalLimits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0249b4e8",
  null
  
)

export default component.exports